/**
 * AirdropResult Component
 *
 * Displays the results of an airdrop execution.
 *
 * @component
 */

import React from "react";
import { colors, gradients, commonStyles } from "../styles";
import StatsCard, { StatsContainer } from "./StatsCard";

const AirdropResult = ({ result }) => {
  if (!result) return null;

  return (
    <div
      className="airdrop-result panel"
      style={{
        ...commonStyles.panel,
        marginTop: "24px",
      }}
    >
      <h3 style={commonStyles.panelHeader}>Airdrop Result</h3>

      {/* Stats Summary */}
      <div style={{ padding: "20px" }}>
        <StatsContainer>
          <StatsCard
            value={result.successCount || 0}
            label="Successful"
            variant="success"
          />
          <StatsCard
            value={result.failureCount || 0}
            label="Failed"
            variant="danger"
          />
          <StatsCard
            value={result.totalAmount || "0"}
            label="Total Amount"
            variant="primary"
          />
        </StatsContainer>
      </div>

      {/* Transfer Details Table */}
      {result.results && result.results.length > 0 && (
        <div style={{ padding: "0 20px 20px" }}>
          <h4
            style={{
              margin: "0 0 12px 0",
              padding: "12px 16px",
              background: colors.gray100,
              border: `1px solid ${colors.border}`,
              borderRadius: "4px",
              fontSize: "14px",
              fontWeight: 600,
              color: colors.primary,
            }}
          >
            Transfer Details
          </h4>
          <div className="index_table_container">
            <table className="index_table result-table">
              <thead>
                <tr>
                  <th className="col">Recipient</th>
                  <th className="col col-status">Status</th>
                  <th className="col">Amount</th>
                  <th className="col">Transaction ID</th>
                  <th className="col">Error</th>
                </tr>
              </thead>
              <tbody>
                {result.results.slice(0, 100).map((item, idx) => (
                  <tr
                    key={idx}
                    className={`${
                      item.status === "success" ? "success-row" : "error-row"
                    } ${idx % 2 === 0 ? "even" : "odd"}`}
                  >
                    <td className="col col-address">
                      <code>
                        {item.recipientAccountId ||
                          item.recipientUserExtId ||
                          "-"}
                      </code>
                    </td>
                    <td className="col col-status">
                      <span className={`status_tag ${item.status}`}>
                        {item.status}
                      </span>
                    </td>
                    <td className="col">{item.amount || "-"}</td>
                    <td className="col col-tx">
                      {item.transactionId ? (
                        <code>{item.transactionId}</code>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="col col-error">{item.error || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {result.results.length > 100 && (
            <p className="more-results">
              Showing first 100 of {result.results.length} results
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default AirdropResult;
